import { useState } from "react";
import { useLocation } from "react-router-dom";
import { acknowledgeChange } from "../../api/monitoring";
import type { ChangeOut } from "../../api/types";
import styles from "../../components/ToolPage/ToolPage.module.css";
export function MonitoringAttention({
  changes,
  onRefresh,
}: {
  changes: ChangeOut[];
  onRefresh: () => Promise<unknown>;
}) {
  const { search } = useLocation();
  const [pending, setPending] = useState<string | null>(null),
    [error, setError] = useState("");
  if (!changes.length) return null;
  const acknowledge = async (id: string) => {
    if (pending) return;
    setPending(id);
    setError("");
    try {
      await acknowledgeChange(id);
      await onRefresh();
    } catch {
      setError("Could not acknowledge the change. Please try again.");
    } finally {
      setPending(null);
    }
  };
  return (
    <details
      className={styles.notice}
      open={
        new URLSearchParams(search).get("changes") === "1" ? true : undefined
      }
    >
      <summary>
        {changes.length === 50 ? "Latest 50" : changes.length} unacknowledged
        changes
      </summary>
      {error && <p role="alert">{error}</p>}
      <ul>
        {changes.slice(0, 5).map((change) => (
          <li key={change.id}>
            <strong>{change.field}</strong> · {change.severity}
            <p>{change.url}</p>
            <p>
              {change.before || "Empty"} → {change.after || "Empty"}
            </p>
            <button
              type="button"
              className={styles.secondary}
              disabled={!!pending}
              onClick={() => {
                void acknowledge(change.id);
              }}
            >
              {pending === change.id ? "Saving…" : "Acknowledge change"}
            </button>
          </li>
        ))}
      </ul>
      {changes.length > 5 && (
        <p>
          Showing five changes. Acknowledge these to reveal the next changes.
        </p>
      )}
    </details>
  );
}
